@let frontendUrl = frontendUrl$ | async;

<div class="dialog-container">
  <button mat-icon-button mat-dialog-close>
    <gb-icon icon="close"></gb-icon>
  </button>

  <div class="dialog-header">
    <mat-icon class="check-circle" color="primary">check_circle</mat-icon>
    <h1 class="dialog-title" translate="SETUP_GUIDE.COMPLETE_DIALOG.TITLE"></h1>
  </div>

  @if (frontendUrl) {
    <div class="dialog-content">
      <h3 translate="SETUP_GUIDE.COMPLETE_DIALOG.BODY"></h3>

      <div class="callout">
        <div class="copy-container">
          <span class="copy-text" (click)="openUrl(frontendUrl)">{{ frontendUrl }}</span>
          <div (click)="copyUrl(frontendUrl)" class="copy-icon">
            <gb-icon height="18px" icon="copy"></gb-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- Hidden QR code for generating download link -->
    <qrcode (qrCodeURL)="onChangeURL($event)" [qrdata]="frontendUrl" [width]="400" hidden></qrcode>
    <a [href]="qrCodeDownloadLink" download="QRCode">
      <button mat-flat-button>
        <div class="button-content">
          <gb-icon icon="qr-code" height="18px"></gb-icon>
          <span translate="QR_CODE.DOWNLOAD"></span>
        </div>
      </button>
    </a>
  }

  <div class="help-section">
    <span class="help-text" translate="SETUP_GUIDE.NEED_MORE_HELP"></span>
    <a class="help-link" [gbRouteNewTab]="'/help'" mat-dialog-close>
      <span translate="SETUP_GUIDE.CHECK_OUT_HELP_SECTION"></span>
      <gb-icon icon="caret-forward-outline" height="18px"></gb-icon>
    </a>
  </div>
</div>
